import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-24 px-6" data-id="element-141">
      <div className="max-w-5xl mx-auto" data-id="element-142">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-143">
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-144">El Problema</h2>
          <div className="w-24 h-1 bg-red-500/50 mx-auto rounded-full" data-id="element-145" />
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-146">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-white/[0.02] border border-white/5 p-8 rounded-2xl relative overflow-hidden group hover:border-red-500/30 transition-colors" data-id="element-147">
            <div className="absolute top-0 left-0 w-1 h-full bg-red-500/50" data-id="element-148" />
            <AlertTriangleIcon className="w-8 h-8 text-red-400 mb-6" data-id="element-149" />
            <p className="text-lg text-gray-400 leading-relaxed" data-id="element-150">
              Crecimos viendo a nuestros padres trabajar 60 horas a la semana
              para terminar pagando intereses eternos en tarjetas de crédito o
              préstamos de autos basura.{' '}
              <strong className="text-white" data-id="element-151">
                No lo hicieron por falta de ganas, sino por falta de
                información.
              </strong>
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} className="bg-white/[0.02] border border-white/5 p-8 rounded-2xl relative overflow-hidden group hover:border-red-500/30 transition-colors" data-id="element-152">
            <div className="absolute top-0 left-0 w-1 h-full bg-red-500/50" data-id="element-153" />
            <AlertTriangleIcon className="w-8 h-8 text-red-400 mb-6" data-id="element-154" />
            <p className="text-lg text-gray-400 leading-relaxed" data-id="element-155">
              Hoy, tú corres el mismo riesgo. El sistema de consumo en USA está
              diseñado para que los jóvenes vivan "cheque a cheque", atrapados
              en una trampa de estatus y deuda de la que es casi imposible salir
              después de los 30 años.{' '}
              <strong className="text-white" data-id="element-156">
                Si no aprendes a jugar el juego del crédito y la inversión hoy,
                terminarás trabajando solo para pagar tus deudas, igual que las
                generaciones anteriores.
              </strong>
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}